import clsx from 'clsx';
import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import Button from "../../../../../../common/Button";
import Title from "./Title";
import Tip from "./tip/Tip";
import CorrectAnswer from './tip/CorrectAnswer';
import { TYPE } from '../../../../../../../constant';
import HackleNoteBtn from '../../../../../../common/HackleNoteBtn';
import HackleLearningDelBtn from '../../../../../../common/HackleLearningDelBtn';

const Directive = ( props ) => {
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const questionView = useSelector( state => state.questionView );
  const useInfo = useSelector( state => state.user.info );

  const {
    QuestionTipHider,
    ScribbleCleaner,
    ScribbleErase,
    CorrectAnswerDevelop
  } = props;

  return (
    <div className="learning_head">
      <div className="mathQuest-wrap">
        <Title>{ answeringQuestions.data.textCn }</Title>
        {process.env.REACT_APP_ENV !== 'production' && <CorrectAnswerDevelop><CorrectAnswer /></CorrectAnswerDevelop>}
        { answeringQuestions.data.exmpCn && <QuestionTipHider><Tip /></QuestionTipHider> }
        {
          useInfo.channelCode !== TYPE.ENTRY_TYPE.GLOBAL01 && 
          answeringQuestions.isShowKeypad && <Button className="note_btn">연습장</Button>
        }
        {
          useInfo.channelCode === TYPE.ENTRY_TYPE.GLOBAL01 &&
          answeringQuestions.isShowKeypad && <HackleNoteBtn { ...props } location='viewer' />
        }
      </div>
      {
        !answeringQuestions.isShowKeypad && questionView.isScribble && (
          <div className="btn_wrap scratch">
            <ScribbleErase>
              <Buttons />
            </ScribbleErase>
          </div>
        )
      }

      {
        useInfo.channelCode !== TYPE.ENTRY_TYPE.GLOBAL01 && (
          <ScribbleCleaner>
            { 
              !answeringQuestions.isShowKeypad && questionView.isScribble && 
              <Button className="btn-learning-del on">삭제</Button>
            }            
          </ScribbleCleaner>
        )
      }
      {
        useInfo.channelCode === TYPE.ENTRY_TYPE.GLOBAL01 && (
          <ScribbleCleaner>
            { 
              !answeringQuestions.isShowKeypad && questionView.isScribble && 
              <HackleLearningDelBtn { ...props } />
            }
          </ScribbleCleaner>
        )
      }
    </div>
  );

};

const Buttons = (props) => {
  const questionView = useSelector(state => state.questionView);
  return (
    <div className="pos_rgt">
      <button
        type="button"
        className={clsx(
          "bg_ple wht pen",
          questionView.isErase ? 'off' : 'on'
        )}
        onClick={() => props.handleEraseClick(false)}
      />
      <button
        type="button"
        className={clsx(
          "bg_ple wht eraser",
          questionView.isErase ? 'on' : 'off'
        )}
        onClick={() => props.handleEraseClick(true)} />
      <button 
        type="button" 
        className="bg_ple wht prev off"
        onClick={props.handleUndoClick}
      />
      {/* <button type="button" className="bg_ple wht next off"></button> */}
    </div>
  )
}

Directive.defaultProps = {
  QuestionTipHider : Fragment,
  ScribbleCleaner : Fragment,
  ScribbleErase: Fragment
};

export default Directive;
